import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Container, Stack } from '@mui/material';
import { MdBusiness, MdWork, MdPerson } from 'react-icons/md';
import Header from '../../header/header';
import Footer from '../../commun/Footer';
import './signup.css';

const Signup = () => {
  const navigate = useNavigate();

  const cards = [
    {
      icon: <MdBusiness size={64} />,
      title: 'Entreprise',
      description:
        'Publiez vos besoins, accédez à un réseau de recruteurs indépendants et suivez vos recrutements en toute simplicité.',
      route: '/signup/entreprise',
    },
    {
      icon: <MdWork size={64} />,
      title: 'Recruteur·euse',
      description:
        "Profitez d’un flux continu de missions, proposez des profils et générez des revenus à la hauteur de votre implication.",
      route: '/signup/recruteur',
    },
    {
      icon: <MdPerson size={64} />,
      title: 'Candidat·e',
      description:
        "Déposez votre CV, soyez contacté pour des missions alignées avec vos compétences, sans démarche active.",
      route: '/signup/candidat',
    },
  ];

  return (
    <Box>
      <Box className="signup-page">
        <Header />
        <Container maxWidth="lg" className="signup-container">
          <Typography variant="h4" align="center" gutterBottom>
            Accédez à la plateforme
          </Typography>

          <Box className="cards-wrapper">
            {cards.map(({ icon, title, description, route }) => (
              <Card key={route} onClick={() => navigate(route)} className="signup-card">
                <Stack alignItems="center" padding={3}>
                  <Box className="icon-box">{icon}</Box>
                  <CardContent>
                    <Typography variant="h6" gutterBottom align="center">
                      {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center">
                      {description}
                    </Typography>
                  </CardContent>
                </Stack>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default Signup;
